<template>
  <v-container>
    <v-responsive
      class="mx-auto px-3 px-md-12"
      max-width="750"
    >
      <div
        class="text-center"
        width="100%"
      >
        <h1>
          Buy the Full Versions
        </h1>
        <br>
        <div v-if="userIsAuthenticated">
          <h3>
            Important: After purchase your Unlock Code(s) will be emailed to you and it will also be visible in the User Area.
          </h3>
          <stripe-buy-button
            buy-button-id="buy_btn_1PMLFdDUmppTYnj9loyAdofh"
            publishable-key="pk_live_51Mj4oRDUmppTYnj9WHakDulLWD1KExi6KGnlwfD1FJEKYTcjkfzz3rNDnRsbVwFqEhRiORI2WCM72Pay37a2QSbO00Y2sX4wBs"
          >
          </stripe-buy-button>
          <h4>
            License includes free updates until version 1.X.X. Starting with version 2.0.0, a new license will be required. You may run Annaliis on up to 2 computers.
          </h4>
          <br>
          <stripe-buy-button
            buy-button-id="buy_btn_1R2wZgDUmppTYnj9zvWPi7H9"
            publishable-key="pk_live_51Mj4oRDUmppTYnj9WHakDulLWD1KExi6KGnlwfD1FJEKYTcjkfzz3rNDnRsbVwFqEhRiORI2WCM72Pay37a2QSbO00Y2sX4wBs"
          >
          </stripe-buy-button>
          <h4>
            License includes free updates until version 1.X.X. Starting with version 2.0.0, a new license will be required. You may run MES Arpeggiator on up to 2 computers.
          </h4>
          <br>
          <stripe-buy-button
            buy-button-id="buy_btn_1R2wbnDUmppTYnj9EQ99S5n3"
            publishable-key="pk_live_51Mj4oRDUmppTYnj9WHakDulLWD1KExi6KGnlwfD1FJEKYTcjkfzz3rNDnRsbVwFqEhRiORI2WCM72Pay37a2QSbO00Y2sX4wBs"
          >
          </stripe-buy-button>
          <h4>
            Licenses include free updates until version 1.X.X. Starting with version 2.0.0, new licenses will be required. You may run Annaliis and MES Arpeggiator on up to 2 computers.
          </h4>
          <br>
        </div>
        <div v-else>
          <div class="center-text">
            <h2>
              Annaliis Synthesizer
            </h2>
            <h3>
              US$149
            </h3>
            <br>
            <v-img
              class="mx-auto"
              height="15vh"
              width="15vh"
              :src="require('../../../assets/AnnaliisA.png')"
            />
            <br>
            <router-link
              to="/signup"
              class="center-text-2"
            >
              <h2>Please sign up to buy</h2>
            </router-link>
            <br>
            <h2>
              MES Arpeggiator
            </h2>
            <h3>
              US$25
            </h3>
            <br>
            <v-img
              class="mx-auto"
              height="15vh"
              width="15vh"
              :src="require('../../../assets/MESArp.png')"
            />
            <br>
            <router-link
              to="/signup"
              class="center-text-2"
            >
              <h2>Please sign up to buy</h2>
            </router-link>
            <br>
            <h2>
              Annaliis + MES Arpeggiator
            </h2>
            <h3>
              US$155
            </h3>
            <br>
            <v-img
              class="mx-auto"
              height="15vh"
              width="15vh"
              :src="require('../../../assets/Annaliis+MESArp.png')"
            />
            <br>
            <router-link
              to="/signup"
              class="center-text-2"
            >
              <h2>Please sign up to buy</h2>
            </router-link>
            <br>
          </div>
        </div>
      </div>
    </v-responsive>
  </v-container>
</template>
  <script>
  export default {
    data () {
      return {
        checkInterval: null, // Store the interval ID
      }
    },
    computed: {
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      userPurchased () {
        return this.$store.getters.purchased
      }
    },
    beforeMount () {
      // this.$store.dispatch('getUserData', { user: this.$store.getters.user })
    },
    beforeDestroy () {
      // Clear the interval when the component is about to be destroyed
      clearInterval(this.userDataInterval)
      if (this.checkInterval) {
        clearInterval(this.checkInterval) // Clear the interval when the component is destroyed
      }
    },

    methods: {
      handleButtonClick (buttonType) {
        if (buttonType === 'Sign Up') {
          this.$router.push({ name: 'Sign Up' })
          // trackEvent({
          //   event: `${buttonType} Button Hit`,
          //   event_category: 'Button Clicks',
          //   event_action: 'Click',
          //   event_label: 'Sign Up Button Hit From Buy Page'
          // })
        } else if (buttonType === 'Go To User Area') {
          this.$router.push({ name: 'User Area' })
          // trackEvent({
          //   event: `${buttonType} Button Hit`,
          //   event_category: 'Button Clicks',
          //   event_action: 'Click',
          //   event_label: 'Go To User Area Button Hit From Buy Page'
          // })
        }
      },

      fetchUserData () {
        // Dispatch the getUserData action
        // this.$store.dispatch('getUserData', { user: this.$store.getters.user })
      },

      isUserLoggedIn () {
        return this.$store.getters.isUserLoggedIn
      }
    }

  }
  </script>

<style scoped>
.cta-buttons {
  display: flex;
  justify-content: center; /* Centering the buttons */
  padding: 20px;
  gap: 20px; /* Adds space between buttons */
}

.cta-button {
  padding: 10px 40px; /* Increased horizontal padding */
  border: none;
  border-radius: 5px;
  font-size: 18px; /* Slightly larger font size */
  cursor: pointer;
  transition: background-color 0.3s;
  min-width: 150px; /* Minimum width */
  background-color: #4CAF50; /* Green */
  color: white;
}

.cta-button:hover {
  opacity: 0.9;
}

.center-text-2 {
  text-align: center;
  color: #4CAF50;
}
</style>
